module.exports = __webpack_public_path__ + "assets/img/page4-nav-item-2-e50d64fa.png";